import React, { useState, useEffect } from "react";
import styles from "./components/Css/Startwiththese.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useNavigate } from "react-router-dom";
import Loading from "../common/HousGlass Loader/Loading";
import { useAudiosByAudioType } from "../hooks/useAudiosHooks";

const StartWithThese = () => {
    const [visibleItems, setVisibleItems] = useState(10); // Number of items to display
    const navigate = useNavigate();
    const { data: response, isLoading, error } = useAudiosByAudioType('Audio Book');
    
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        // Check if device is mobile or desktop
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    if (isLoading) {
        return <div className={styles.loading}><Loading/></div>;
    }

    if (error) {
        return <div className={styles.error}>Error: {error}</div>;
    }

    // Extract audio items from the response data
    const audioItems = response?.data || [];
    
    // Filter out items that don't have audio_url or required images
    const validAudioItems = audioItems.filter(item => 
        item.audio_url && (item.computer_image_url || item.mobile_image_url)
    );

    return (
        <div className={styles.container}>
            <div className={styles.boxedWrapper}>
                <div className={styles.header}>
                    <h2>Start with these</h2>
                    <button onClick={() => navigate('/ReadMore')} className={styles.viewAllButton}>
                        View all &gt;
                    </button>
                </div>
                <div className={styles.bookList}>
                    <Swiper
                        modules={[Navigation, Mousewheel]}
                        navigation
                        mousewheel={{ forceToAxis: true, invert: false }}
                        spaceBetween={20}
                        slidesPerView={1}
                        breakpoints={{
                            320: { slidesPerView: 3, spaceBetween: 10 },
                            480: { slidesPerView: 3, spaceBetween: 12 },
                            768: { slidesPerView: 4, spaceBetween: 20 },
                            1024: { slidesPerView: 7, spaceBetween: 20 },
                            1440: { slidesPerView: 7, spaceBetween: 20 },
                        }}
                        className={styles.swiper}
                    >
                        {validAudioItems.length > 0 ? (
                            validAudioItems.slice(0, visibleItems).map((item) => (
                                <SwiperSlide key={item.id}>
                                    <div 
                                        className={styles.bookItem}
                                        onClick={()=>navigate(`/audio-play/${item.slug}`)}
                                    >
                                        <img 
                                            src={isMobile ? item.mobile_image_url : item.computer_image_url} 
                                            alt={item.title || item.series_title} 
                                            className={styles.bookImage} 
                                            onError={(e) => {
                                                // Fallback to series cover if audio image fails
                                                e.target.src = item.series_cover_image;
                                            }}
                                        />
                                    </div>
                                </SwiperSlide>
                            ))
                        ) : (
                            <div className={styles.noItems}>No audio content found</div>
                        )}
                    </Swiper>
                </div>
                {validAudioItems.length > visibleItems && (
                    <button onClick={() => setVisibleItems((prev) => prev + 5)} className={styles.viewAllButton}>
                        Show More
                    </button>
                )}
            </div>
        </div>
    );
};

export default StartWithThese;